export const LOGIN_INIT = "LOGIN_INIT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const UPDATE_VALUE = "UPDATE_VALUE";
export const LOGOUT_INIT = "LOGOUT_INIT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const CONFIG_DATA = "CONFIG_DATA";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";